module.exports = __webpack_public_path__ + "static/media/Pit-Pay-Logo.e8797993.svg";